<template>
  <div id="card-promo-code">
    <div class="head-card">
      <p class="raleway-reg-p24">Vos codes exclusifs</p>
      <p class="raleway-reg-p15">Retrouvez l’ensemble de vos codes juste ici et pensez à les utiliser avant leur date de validité.</p>
    </div>
    <div class="green-section mt-4">
      <!-- <template v-for="promoCode in this.promoCodes"> -->
        <div class="promo-code-labels text-uppercase" v-if="!isPhone">
          <p class="raleway-reg-p15 mb-2"><strong>Code à utiliser</strong></p>
          <p class="raleway-reg-p15 mb-2"><strong>Offres promotionnelles</strong></p>
          <p class="raleway-reg-p15 mb-0"><strong>Date de validité</strong></p>
        </div>
        <div class="green-night mb-3">
          <p class="raleway-bold-p mb-0">BIENVENUE</p>
          <p class="raleway-reg-p15 mb-0">- 10% sur votre premier séjour</p>
          <p class="raleway-reg-p15 mb-0">{{ this.validityDate }}</p>
        </div>
        <div class="green-night mb-3" v-if="userDiscountCode">
          <p class="raleway-bold-p mb-0">{{ userDiscountCode.discount_code }}</p>
          <p class="raleway-reg-p15 mb-0">{{ userDiscountCode.discount_amount }}{{ userDiscountCode.discount_type == 'percent' ? '%' : '€' }}</p>
          <p class="raleway-reg-p15 mb-0">{{ formatDate(userDiscountCode.validity_date) }}</p>
        </div>
      <!-- </template> -->
    </div>
    <!-- <p class="raleway-reg-p15 mt-2">Vos points sont échangeables contre des nuits offertes : les Green Nights³. Vous pouvez réduire le montant total de votre séjour en utilisant vos points, directement depuis l’espace de réservation.</p> -->
  </div>
</template>

<script>

  import fetcher from 'packs/shared/api.js';

  export default {
    name: 'card-promo-code',
    props: ["user"],
    data() {
      return {
        userStatut: '',
        userMount: '',
        promoCodes: 1,
        isPhone: window.innerWidth <= 768,
        validityDate: this.user && this.user.created_at 
          ? new Date(new Date(this.user.created_at).setFullYear(new Date(this.user.created_at).getFullYear() + 1)).toLocaleDateString('en-GB') 
          : 'no validity date',
        userDiscountCode: null
      }
    },
    methods: {
      async setUserLevel(){
        const res = await fetcher.get('/dashboard/'+this.user.slug)
        this.userMount = res.data
        this.userDiscountCode = this.userMount.user_discount_codes.length > 0 ? this.userMount.user_discount_codes[0] : null
      },
      formatDate(date) {
        if (!date) return 'no validity date'
        return new Date(date).toLocaleDateString('en-GB')
      }
    },
    mounted() {
      this.setUserLevel();
    },
  }
</script>

<style lang="scss" scoped>

.promo-code-labels {
  display: flex;
  justify-content: space-evenly;
  gap: 15px;
  margin-bottom: 5px;
  
  p {
    color: #3B6152;
    font-weight: 600;
    font-size: 0.95rem;
    margin-bottom: 0;
  }
}

.green-night {
  background-color: #f8f9fa;
  border-left: 4px solid #3B6152;
  padding: 15px;
  border-radius: 5px;
  min-height: 100px;
  justify-content: space-around !important;
}

@media (max-width: 768px) {
  .promo-code-labels {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

</style>
